import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';


import { HomeHeroSection, HomeHeroSecMobile } from './Components/HomeHeroSection';
import Header from '../Header/Header';
import WelcomeStudio from './Components/WelcomeStudio';
import WhatsOn from './Components/What\'sOn';
import MenuImagesSection from './Components/MenuImageSection';
import Backstage from './Components/Backstage';
import { Carousel8 } from './Components/Carousel';
import Footer from '../Footer/Footer';

function HomePage() {
  const [isMobile, setIsMobile] = useState(false);
  const [isAdmin, setIsAdmin] = useState (true)

  let imageItemUrls = {
  
   //What's on Section Images
   image1: { url: "https://www.blackpoolgrand.co.uk/app/uploads/2020/01/Jinjo17_Credit_Belinda_Lawley-1.jpg", altText: "image1dfg" },
   image2: { url: "https://m.media-amazon.com/images/I/31rXhchkvrL._UF894,1000_QL80_.jpg", altText: "image2" },
   image3: { url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ718nztPNJfCbDJjZG8fOkejBnBAeQw5eAUA&s", altText: "image3" },

   //menuImage Section Images
   image4: { url: "https://us.123rf.com/450wm/sanches1980/sanches19801802/sanches1980180200449/96461064-young-beautiful-female-dancer-is-posing-in-the-studio.jpg?ver=6", altText: "image4test" },
   image5: { url: "https://us.123rf.com/450wm/sanches1980/sanches19801802/sanches1980180200449/96461064-young-beautiful-female-dancer-is-posing-in-the-studio.jpg?ver=6", altText: "image5test" },
   image6: { url: "https://us.123rf.com/450wm/sanches1980/sanches19801802/sanches1980180200449/96461064-young-beautiful-female-dancer-is-posing-in-the-studio.jpg?ver=6", altText: "image6test" },
   image7: { url: "https://us.123rf.com/450wm/sanches1980/sanches19801802/sanches1980180200449/96461064-young-beautiful-female-dancer-is-posing-in-the-studio.jpg?ver=6", altText: "image7test" },

   //Backstage Section Images
   image8: { url: "https://ledimoredelquartetto.eu/lddqwp/wp-content/uploads/2024/04/dimore_quartetto_backstage-conversations.jpg.jpg", altText: "image8test" },


  }
  let videoItemUrls = {
    video1: { url: "https://www.youtube.com/embed/tTl40cZnVyk?autoplay=1&mute=1&loop=1&playlist=tTl40cZnVyk&controls=0&showinfo=0&autohide=1&modestbranding=1&rel=0", altText: "Satish moving in the background" }
  }

  let linkItemUrls = {
    link1: { url: "https://www.instagram.com/reel/DM5mzg4Tnbv/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D", altText: "Insta embed code" }
  }

  
  useEffect(() => {
    const detectMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Regular expressions to detect common mobile devices
      if (/android/i.test(userAgent)) {
        return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return true;
      }
      // Add more checks for other mobile devices if needed
      return false;
    };

    setIsMobile(detectMobile());

    const handleResize = () => {
      setIsMobile(detectMobile() || window.innerWidth <= 768); // Combine userAgent with width for broader coverage
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Abcd Studio Salem</title>
        <meta name="description" content="Welcome to our studio! Explore our latest events, backstage content, and more." />
        <meta name="keywords" content="Salem Studio, Salem Events, Salem Dance, Salem Art, Salem Performance, Dance Studio, Art Gallery, Live Events, Event Space, Dance Classes, Art Workshops, Stage Performance, Local Artists, Venue Hire, Backstage Access, Salem Dance Studio, Salem Art Gallery, Salem Event Venue, Salem Performance Space, Best Dance Classes, Top Art Workshops, Live Music Salem, Creative Studio Salem, Professional Dance Studio, Art Exhibition Salem, Performance Arts Salem, Backstage Support Salem, Event Management Salem, Dance Performance Salem, Art Studio Salem, Best Dance Studio Salem, Top Art Gallery Salem, Premier Event Venue Salem, Professional Dance Classes Salem, Live Performance Venue Salem, Salem Performing Arts Center, Creative Art Studio Salem, Salem Backstage Facilities, Local Artists Salem Exhibitions, Dance Performance Events Salem, Art Workshop Classes Salem, Salem Event Management Services, Modern Dance Studio Salem, Traditional Art Gallery Salem, Community Performance Space Salem, Best Multi-purpose Studio for Events in Salem, Top Rated Dance and Art Performance Venue Salem, Professional Backstage Facilities for Events in Salem, Comprehensive Dance and Art Education Programs Salem, Premier Destination for Live Performances and Events Salem, Salem's Leading Studio for Creative Arts and Dance, Exclusive Event Space with Backstage Access in Salem, High-Quality Dance Training and Performance Opportunities Salem, Showcasing Local Art and Talent in Salem Events, State-of-the-Art Performance Venue for Artists in Salem" />
      </Helmet>
      <Header />
      {/* <HomeHeroSection/> */}
      {isMobile ? <HomeHeroSecMobile LinkUrls ={linkItemUrls} ImageUrls={imageItemUrls} VideoUrls={videoItemUrls}/> : <HomeHeroSection LinkUrls ={linkItemUrls} ImageUrls={imageItemUrls} VideoUrls={videoItemUrls}/>}
      <WelcomeStudio/>
      <WhatsOn ImageUrls={imageItemUrls} VideoUrls={videoItemUrls}/>
      <MenuImagesSection ImageUrls={imageItemUrls} VideoUrls={videoItemUrls}/>
      <Backstage ImageUrls={imageItemUrls} VideoUrls={videoItemUrls}/>
      {/* <Carousel8/> */}
      <Footer/> 
    </>
  );
}

export default HomePage;